import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { NgxExtendedPdfViewerService, ScrollModeType } from 'ngx-extended-pdf-viewer';
import { AppPlatformService } from 'src/app/service/platform/app-platform.service';
@Component({
  selector: 'app-pdf-player',
  templateUrl: './pdf-player.component.html',
  styleUrls: ['./pdf-player.component.scss'],
})
export class PdfPlayerComponent  implements OnInit, OnDestroy, OnChanges {
  @Input() pdfUrl:string = "";
  @Input() isPlayerExpanded:boolean = false;
  @Input() displayFullscreen:boolean = true;
  @Input() isfullscreen: boolean = false;
  totalPages: number | null = null;
  private lastPageEmitted: boolean = false;

  @Output() pdfOrientation: EventEmitter<any> = new EventEmitter<any>();
  // @Output() onPageChanging: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLastPageReached: EventEmitter<any> = new EventEmitter<any>();
  @Output() onToggleFullscreen: EventEmitter<any> = new EventEmitter<any>();

  currentPage: number = 1;
  isToolbarVisible: boolean = false;
  private hideToolbarTimeout: any;
  progressPercentage: number = 0;
  public pageViewMode = 'multiple';
  public scrollMode = ScrollModeType.vertical;
  public zoom: string | number = 'page-width';


  constructor(
    private appPlatformService:AppPlatformService,
    private pdfViewerService: NgxExtendedPdfViewerService
  ) { }

  ngOnInit() {
    // console.log("***** Init PdfPlayerComponent...")
  }

  ngOnChanges(changes): void {
    // Detectar cuando cambia videoSrc
    if (changes['pdfUrl'] && !changes['pdfUrl'].firstChange) {
      this.resetPlayer();
    }
    // if (changes['videoSrc'] && !changes['videoSrc'].firstChange) {
    //   this.resetPlayer();
    // }
  }

  ngOnDestroy() {
    if (this.hideToolbarTimeout) {  // AGREGA ESTAS 3 LÍNEAS
      clearTimeout(this.hideToolbarTimeout);
    }
    console.log("Destroy PdfPlayerComp...")
  }

  private resetPlayer(): void {
    // Resetear el estado del reproductor
    this.currentPage = 1;
    this.lastPageEmitted = false;
    this.isToolbarVisible = false;
    this.isfullscreen = false;
    this.pageViewMode = 'multiple';
    this.scrollMode = ScrollModeType.vertical;

  }

  afterLoadComplete(pdf): void {
    this.lastPageEmitted = false;
    this.totalPages = pdf.pagesCount;
    //console.log("total pages: ",pdf);
    this.currentPage = 1;  // AGREGA ESTA LÍNEA
    this.updateProgress();
  }

  pagechanging(e){
    this.currentPage = e;  // AGREGA ESTA LÍNEA
    // console.log("page changing", e, this.totalPages);
    if (this.lastPageEmitted) return;
    // this.onPageChanging.emit(e)
    // e === this.totalPages && media.status_progress !== "revisado"
    this.updateProgress();

    if(e === this.totalPages) {
      this.lastPageEmitted = true;
      // console.log("pdf completed");
      this.onLastPageReached.emit(e)
      // localStorage.setItem("pdfComplete", "true")
    }
  }

  onpageRendered(page, e) {
    if (this.lastPageEmitted) return;

    // console.log("***** on page Rendered ****::",page, e.pageNumber)
    const pageNumber = e.pageNumber;
    if(this.totalPages === 1 && pageNumber === this.totalPages) {
      this.lastPageEmitted = true;
      setTimeout(() => {
        this.onLastPageReached.emit(pageNumber)
      }, 20);
    }
    else if (this.totalPages && pageNumber === this.totalPages && !this.lastPageEmitted) {
      this.lastPageEmitted = true;
      setTimeout(() => {
        this.onLastPageReached.emit(pageNumber)
      }, this.isPlayerExpanded ? 800 : 1000);
    };
}

  onError(err) {
    console.log("*comp error: ",err);
  }

  onPagesLoaded(event: any) {
    // console.log("onPagesLoaded!!")
    if (event && event.source._pages && event.source._pages.length > 0) {
      const firstPage = event.source._pages[0];
      // console.log("firstPage::", event.source._pages.length , event.source._pages)
      const orientation = firstPage.width > firstPage.height ? 'horizontal' : 'vertical';
      this.pdfOrientation.emit(orientation);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      // Forzamos el scroll a la página deseada
      this.pdfViewerService.scrollPageIntoView(this.currentPage, {top: '0%'});
    }
  }

  nextPage() {
    if (this.totalPages && this.currentPage < this.totalPages) {
      this.currentPage += 1;
      // Forzamos el scroll a la página deseada
      this.pdfViewerService.scrollPageIntoView(this.currentPage, {top: '0%'});
    }
    // console.log("nextPage!!!",{currentPage: this.currentPage, totalPages:this.totalPages});
  }

showToolbar() {
  this.isToolbarVisible = true;

  if(this.appPlatformService.isAppPlatform() || this.appPlatformService.isMobileWeb()) {
    if (this.hideToolbarTimeout) {
      clearTimeout(this.hideToolbarTimeout);
    }
    this.hideToolbarTimeout = setTimeout(() => {
      this.isToolbarVisible = false;
    }, 2000);
  };
}


hideToolbar() {
  if (this.hideToolbarTimeout) {
    clearTimeout(this.hideToolbarTimeout);
  }
  // this.hideToolbarTimeout = setTimeout(() => {
    this.isToolbarVisible = false;
    // this.isToolbarVisible = true;
  // }, 500);
}


updateProgress() {
  if (this.totalPages) {
    this.progressPercentage = (this.currentPage / this.totalPages) * 100;
  }
}

toggleFullscreen(): void {
  this.isfullscreen = !this.isfullscreen;
  this.onToggleFullscreen.emit(this.isfullscreen)

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
    this.zoom = 'page-width';
  }, 100);
}

toggleSidebar() {
  const PDFViewerApplication = (window as any).PDFViewerApplication;

  if (PDFViewerApplication?.pdfSidebar) {
    PDFViewerApplication.pdfSidebar.toggle();
  }
}

changeViewMode(viewMode) {
  this.pageViewMode = viewMode;

  this.scrollMode = this.pageViewMode === "single" ? ScrollModeType.page : ScrollModeType.vertical;
  // console.log(this.pageViewMode, this.scrollMode)
}


}
